import Footer from "../Components/Footer";
import Header from "../Components/Header";
import SpecialQuotes from "../Components/SpecialQuotes";

export default function Books() {
  return (
    <div>
      <Header />
      <main id="main" className="main min-height bg-bgWarm">
        <section className="px-3 pb-16">
          <div className="w-full border-b border-heads/20 mb-8 pt-6">
            <div className="mx-auto px-8">
              <div className="mb-6 text-3xl font-bold text-heads font-Philosopher">
                <span>Books</span>
              </div>
            </div>
          </div>
          
          <div className="max-w-7xl mx-auto glassmorphism rounded-2xl p-6 md:p-10 shadow-xl border-t-4 border-main animate-fade-in-up">
            <h2 className=" leading-normal text-accent text-4xl text-center font-bold mb-8">
              अर्थपंचक सिद्धांत
            </h2>
            
            <div className="leading-relaxed md:leading-loose text-justify italic text-lg font-Philosopher text-heads/90 mb-10 bg-white/50 p-6 rounded-xl border border-white/40 shadow-sm">
              यहाँ पर लक्ष्मण जी ने प्रभु से अर्थपंचक सिद्धान्त के पाँच प्रश्न
              किये हैं जिनमें माया का प्रश्न विरोधी स्वरूप, ज्ञान, वैराग्य, साधन
              भक्ति का प्रश्न उपाय स्वरूप, ईश्वर और जीव का भेद परस्वरूप और
              स्वस्वरूप है वही भगवत चरण में रति अर्थात प्रेमलक्षणा भक्ति है जो
              शोक, मोह, भ्रम की समाप्ति के फल स्वरूप है।श्री राम ने भी इसीलिए
              क्रम से पहले माया का विवेचन, फिर ज्ञान, वैराग्य का विवेचन पुनः
              ईश्वर, जीव का भेद का विवेचन और पुनः प्रेमलक्षणा भक्ति का विवेचन
              किया। अर्थात् परस्वरूप, स्वस्वरूप, उपाय स्वरूप, फल स्वरूप और
              विरोधी स्वरूप यही अर्थपंचक है ।
            </div>
            
            <div className="flex flex-col md:flex-row justify-between gap-10 items-center">
              <div className="w-full md:w-3/5 flex flex-col justify-center">
                <div className="bg-white/30 rounded-xl p-4 shadow-sm border border-white/20 mb-8">
                  <SpecialQuotes
                    nosvg
                    data={{
                      stanza1:
                        "थोरेहि महँ सब कहउँ बुझाई। सुनहु तात मन मति चित लाई।।",
                    }}
                  />
                </div>
                
                <div className="mb-10 text-2xl leading-relaxed text-heads  font-semibold space-y-3 bg-white/40 p-6 rounded-xl shadow-inner border border-white/30">
                  <p className="flex items-center"><span className="text-accent mr-3">1.</span> माया क्या है?</p>
                  <p className="flex items-center"><span className="text-accent mr-3">2.</span> ज्ञान क्या है?</p>
                  <p className="flex items-center"><span className="text-accent mr-3">3.</span> वैराग्य क्या है?</p>
                  <p className="flex items-center"><span className="text-accent mr-3">4.</span> ईश्वर और जीव में क्या भेद है?</p>
                  <p className="flex items-center"><span className="text-accent mr-3">5.</span> भक्ति क्या है?</p>
                </div>
                
                <div className="text-center md:text-left">
                  <a
                    href="https://drive.google.com/file/d/125JxLyD4GQ94k5rvB1oI3O635ioIGSVl/view"
                    target="_blank"
                    rel="noreferrer"
                    type="button"
                    className="font-Philosopher inline-block focus:outline-none text-white bg-main hover:bg-mainDark font-bold rounded-full text-xl px-10 py-4 shadow-lg hover:shadow-2xl transform transition-transform hover:-translate-y-1 focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-900"
                  >
                    Get Book
                  </a>
                </div>
              </div>
              
              <div className="w-full md:w-2/5 flex justify-center">
                <img
                  className="rounded-xl shadow-2xl border-4 border-white transform transition-transform hover:scale-105 duration-300"
                  alt="Artha Panchak Siddhanta"
                  src={require("../assets/Arth Panchak Siddhant.jpg")}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
